module.exports = __webpack_public_path__ + "img/img-3-11.d59e07c3.png";